import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
    const options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, {encode: false});
        }
    };

    return axios.get(`${url}/typeLines`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/typeLines/${id}`, options)
        .then(response => {
            let typeLine = jsona.deserialize(response.data);
            delete typeLine.links;
            return typeLine;
        });
}

function add(typeLine) {
    const payload = jsona.serialize({
        stuff: typeLine,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/typeLines`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update(typeLine) {
    const payload = jsona.serialize({
        stuff: typeLine,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/typeLines/${typeLine.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/typeLines/${id}`, options);
}


export default {
    list,
    get,
    add,
    update,
    destroy
};

